import type React from 'react';

import styles from './styles.module.less';

export const WorkflowCanvasZoomable: React.FC = () => {
  return <div className={styles.canvas} />;
};
